import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Blog = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const [blogPost, setBlogPost] = useState([])

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          'https://dev.to/search/feed_content?per_page=15&page=0&user_id=657378&class_name=Article&sort_by=published_at&sort_direction=desc&approved='
        )

        const data = await response.json()

        const extractedData = data.result.map((article) => ({
          id: article.id,
          title: article.title,
          path: article.path,
          reading_time: article.reading_time,
        }))
        console.log(extractedData)
        setBlogPost(extractedData)

        // alert(blogPost.result[0].id)
      } catch {
        console.error('not working')
      }
    }
    fetchData()
  }, [])

  return (
    <>
      <div className="container blog-page mywork-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['B', 'l', 'o', 'g', 's']}
              idx={15}
            />
          </h1>

          <div className="blogList">
            <ul>
              {blogPost.map((blog) => (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`https://dev.to${blog.path}`}
                >
                  <li key={blog.id}>
                    <h2>{blog.title}</h2>
                    <p className="reading-time">
                      {blog.reading_time < 1 ? (
                        '1 min'
                      ) : (
                        <>{`${blog.reading_time} min`}</>
                      )}
                    </p>
                    {/* {blog.path} */}
                  </li>
                </a>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <Loader type="line-scale" />
    </>
  )
}

export default Blog
